import { render, staticRenderFns } from "./FloatingRobotLink.vue?vue&type=template&id=19edb7a8&scoped=true"
import script from "./FloatingRobotLink.vue?vue&type=script&lang=js"
export * from "./FloatingRobotLink.vue?vue&type=script&lang=js"
import style0 from "./FloatingRobotLink.vue?vue&type=style&index=0&id=19edb7a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19edb7a8",
  null
  
)

export default component.exports